import styled from '@emotion/styled';
import { breakpoints } from '~/theme';

export const List = styled.ul(({ theme }) => ({
    '--gap': theme.space[1],
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--gap)',
    marginBottom: theme.space[5],

    [breakpoints.xxs]: {
        '--gap': theme.space[2],
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
}));

export const Item = styled.li(({ theme }) => ({
    display: 'flex',
    gap: theme.space[1],
    alignItems: 'center',
}));

export const Text = styled.p(({ theme }) => ({
    fontSize: theme.fontSizes.mouse,
    lineHeight: theme.lineHeights.squirrel,
    letterSpacing: '-0.43px',
    marginTop: 8,
    marginBottom: 5,
}));
